// 想用 axios 则必须先把 axios 引入
// import axios from 'axios';
import { getTaskNum } from "@/services/myTask";

export function disRemoveSentFileUrl({ commit }, option) {
  commit('removeSentFileUrl') // 删除
}

export function removeUpdateUser({ commit }, option) {
  commit('setUpdateUser', option) // 团队管理修改完清空数据
}

export function setMemoryBankList({ commit }, option) {
  commit('setMemory', option) //
}

export const getTaskNums = async({commit ,state}) => {
  let params = {
    userId:JSON.parse(localStorage.getItem("userInfo")).id || state.layout.userInfo.id,
    fileId: 0
  };
  const res = await getTaskNum(params);
  if (res.success && res.status == 200) {
   commit('setTaskNums',res.result)
  }
}